// extracted by mini-css-extract-plugin
export default {"LogosPanel":"LogosPanel_LogosPanel__UPJIv","Image":"LogosPanel_Image__RaD6K"};